import { render, staticRenderFns } from "./relatorioComum.vue?vue&type=template&id=4e7845c0&scoped=true&"
import script from "./relatorioComum.vue?vue&type=script&lang=js&"
export * from "./relatorioComum.vue?vue&type=script&lang=js&"
import style0 from "./relatorioComum.vue?vue&type=style&index=0&id=4e7845c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7845c0",
  null
  
)

export default component.exports